import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  function goSection(id: string) {
    if (location.pathname === "/") {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 120);
    }
  }

  const exploreLinks = [
    { label: t("nav.home"), onClick: () => navigate("/") },
    { label: t("nav.spreadsheet"), onClick: () => navigate("/article") },
    { label: t("nav.creators"), onClick: () => goSection("categories") },
    { label: t("nav.reviews"), onClick: () => goSection("content") },
    { label: t("nav.guides"), onClick: () => navigate("/article") },
  ];

  return (
    <footer className="border-t border-background-300/60 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-grid-line text-lg" />
              </span>
              <span className="whitespace-nowrap font-heading text-lg font-bold text-foreground-950">
                {t("common.brand")}
              </span>
            </Link>
            <p className="mt-4 max-w-xs text-sm text-foreground-600">{t("footer.tagline")}</p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              {t("footer.navTitle")}
            </h4>
            <ul className="mt-4 space-y-2">
              {exploreLinks.map((link) => (
                <li key={link.label}>
                  <button
                    type="button"
                    onClick={link.onClick}
                    className="whitespace-nowrap text-sm text-foreground-600 cursor-pointer transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              {t("footer.categoriesTitle")}
            </h4>
            <ul className="mt-4 flex flex-wrap gap-x-6 gap-y-2 md:grid md:grid-cols-2 md:gap-x-4">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.key}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {t(cat.key)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">{t("footer.disclaimer")}</p>
          <p className="whitespace-nowrap text-xs text-foreground-500">
            © {new Date().getFullYear()} {t("common.brand")}. {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}